import BasePatternDataService from "./base-pattern-data-service";
const INNER_REGEX_EXPRESSION = `(<monday-gradient (.+?)>(.*?)</monday-gradient>)`;
const REGEX_EXPRESSION = `(<monday-gradient .+?>.*?</monday-gradient>)`;
const GRADIENTS = {
    "cyan-purple": "linear-gradient(90deg, rgba(18, 227, 254, 1) 42%, rgba(153, 88, 253, 1) 68%)",
    "cyan-blue": "linear-gradient(90deg, #33dbd0 46.15%, #00baff 66.83%, #0074fd 100%)"
};
class GradientPatternDataService extends BasePatternDataService {
    regex() {
        return REGEX_EXPRESSION;
    }
    isRecursive() {
        return true;
    }
    patternCharsCount() {
        return 0;
    }
    // <monday-gradient cyan-purple>agents</monday-gradient>
    replacer(value) {
        const result = value.match(INNER_REGEX_EXPRESSION);
        const gradientName = result[2];
        const text = result[3];
        const gradient = GRADIENTS[gradientName] || GRADIENTS["cyan-purple"];
        return `<span class="monday-gradient" style="background: ${gradient}; -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; color: transparent; font: inherit;">${text}</span>`;
    }
}
export { GradientPatternDataService as default };
